export const AUTH = 'AUTH'
export const LOADING_LOGIN = 'LOADING_LOGIN'
export const LOADING_SIGNUP = 'LOADING_SIGNUP'
export const LOGOUT = 'LOGOUT'
export const AUTH_ERROR = 'AUTH_ERROR'
export const ERRORS = 'ERRORS'
export const LOADING_APP = 'LOADING_APP'
export const SET_SCHOOL_LOCATION = 'SET_SCHOOL_LOCATION'
export const SET_SCHOOL_LOCATIONS = 'SET_SCHOOL_LOCATIONS'
export const SET_ACADEMIC_YEAR = 'SET_ACADEMIC_YEAR'
export const SET_SELECTED_BRANCH = 'SET_SELECTED_BRANCH'
export const GETTING_ACC_CHART = 'GETTING_ACC_CHART';
export const GET_ACC_CHART_TREE = 'GET_ACC_CHART_TREE';